<ion-card class="application-chain-card" [ngClass]="{ selected: selected }">
    <div class="program-image-thumbnail">
        <img
            class="program-image"
            [src]="
                application?.Program?.image
                    | img: application?.Program?.state:'md'
            "
        />
    </div>
    <ion-card-content class="ion-no-padding">
        <ion-text>
            <p
                class="application-title heavy small-font"
                (click)="scrollToDetails()"
            >
                {{ application?.name }}
            </p>
            <div class="in-fx">
                <fa-icon [icon]="faMapMarkerAlt"></fa-icon>
                <div>
                    <span class="heavy line-lead small-font"
                        >Reporting Location:
                    </span>
                    <span class="small-font">{{
                        application?.Program?.programlocation
                    }}</span>
                </div>
            </div>
            <div class="in-fx">
                <fa-icon [icon]="faClock"></fa-icon>
                <div>
                    <span class="heavy line-lead small-font"
                        >Reporting Time:
                    </span>
                    <span class="small-font">{{
                        application?.Program?.reportingtime
                    }}</span>
                </div>
            </div>
            <div class="in-fx">
                <fa-icon [icon]="faUserMd"></fa-icon>
                <div>
                    <span class="heavy line-lead small-font"
                        >Reporting Physician:
                    </span>
                    <span class="small-font">{{
                        application?.Program?.Host?.name
                    }}</span>
                </div>
            </div>
            <div class="in-fx">
                <fa-icon [icon]="faBriefcaseMedical"></fa-icon>
                <div>
                    <span class="heavy line-lead small-font"
                        >Clinical Experience:
                    </span>
                    <span class="small-font">{{
                        application?.Program?.exposuretype
                    }}</span>
                </div>
            </div>
            <div class="in-fx">
                <fa-icon [icon]="faCalendarAlt"></fa-icon>
                <div>
                    <span class="heavy line-lead small-font">Dates: </span>
                    <span class="small-font"
                        >{{ application?.startdate | date: 'longDate':'UTC' }} -
                        {{
                            application?.enddate | date: 'longDate':'UTC'
                        }}</span
                    >
                </div>
            </div>
        </ion-text>
    </ion-card-content>
</ion-card>
